import { render, staticRenderFns } from "./new-position.vue?vue&type=template&id=d09165be&scoped=true"
import script from "./new-position.vue?vue&type=script&lang=js"
export * from "./new-position.vue?vue&type=script&lang=js"
import style0 from "./new-position.vue?vue&type=style&index=0&id=d09165be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09165be",
  null
  
)

export default component.exports